import {
  PRO014_BULK_ACTION,
  PRO014_ITEM_SORT,
  PRO014_ITEM_STATUS_FILTER,
} from "@/@types/campaign";
import type { Pro014BulkAction } from "@/@types/campaign";
import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from "@/constants/pagination";

import { COMMON_TEXTS } from "../utils/messages";

export const PRODUCTS_FILTER_KEY = {
  PAGE: "page",
  LIMIT: "limit",
  STATUS: "status",
  SEARCH: "search",
  SORT: "sort",
  STORE_CODE: "storeCode",
} as const;

export const PRODUCTS_DEFAULTS = {
  PAGE: DEFAULT_PAGE,
  LIMIT: DEFAULT_PER_PAGE,
  STATUS: PRO014_ITEM_STATUS_FILTER.ALL,
  SORT: PRO014_ITEM_SORT.CODE_ASC,
} as const;

export const PRODUCTS_PAGE_SIZES: number[] = [10, 25, 50, 100];
export const ALL_STORES_FILTER = "all";
export const NO_STORE_FILTER = "";
export const SKELETON_ROWS = 10;
export const DEFAULT_CAMPAIGN_TYPE = "pro014";

export const PRODUCTS_BULK_TITLE: Record<Pro014BulkAction, string> = {
  [PRO014_BULK_ACTION.ACTIVATE]: "Ativar Produtos",
  [PRO014_BULK_ACTION.DEACTIVATE]: "Desativar Produtos",
};

export const PRODUCTS_BULK_QUESTION: Record<Pro014BulkAction, (count: number) => string> = {
  [PRO014_BULK_ACTION.ACTIVATE]: (count: number): string =>
    `Deseja ativar ${count} produto(s) selecionado(s)?`,
  [PRO014_BULK_ACTION.DEACTIVATE]: (count: number): string =>
    `Deseja desativar ${count} produto(s) selecionado(s)?`,
};

export const PRODUCTS_TEXTS = {
  TITLE: (type: string, code: string): string => `Produtos da Campanha ${type} #${code}`,
  DESCRIPTION: "Gerencie os produtos vinculados a esta campanha",
  BACK: "Voltar para Campanhas",
  ADD_PRODUCT: COMMON_TEXTS.ADD_PRODUCT,
  TOTAL: "Total",
  ACTIVE: "Ativos",
  INACTIVE: "Inativos",
  SEARCH_PLACEHOLDER: "Buscar por código ou nome...",
  STORE_FILTER: "Loja",
  ALL_STORES: COMMON_TEXTS.ALL_STORES,
  STORE_OPTION: COMMON_TEXTS.STORE_LABEL,
  STATUS_FILTER: "Status",
  STATUS_ALL: "Todos",
  STATUS_ACTIVE: "Somente Ativos",
  STATUS_INACTIVE: "Somente Inativos",
  SORT_FILTER: "Ordenar",
  SORT_CODE_ASC: "Código (A-Z)",
  SORT_CODE_DESC: "Código (Z-A)",
  SORT_NAME_ASC: "Nome (A-Z)",
  SORT_NAME_DESC: "Nome (Z-A)",
  SELECTED: (count: number): string => `${count} itens selecionados`,
  ACTIVATE_SELECTED: "Ativar Selecionados",
  DEACTIVATE_SELECTED: "Desativar Selecionados",
  COLUMN_STORE: "Loja",
  COLUMN_CODE: "Código",
  COLUMN_NAME: "Nome do Item",
  COLUMN_STATUS: "Status",
  COLUMN_GRADE: "Grade",
  COLUMN_ACTIONS: "Ações",
  SELECT_ALL: "Selecionar todos os produtos da página",
  SELECT_ITEM: (itemCode: string): string => `Selecionar o produto ${itemCode}`,
  ACTIVE_BADGE: "ATIVO",
  INACTIVE_BADGE: "INATIVO",
  EMPTY_NAME: "-",
  ACTIVATE: "Ativar",
  DEACTIVATE: "Desativar",
  PAGE_SIZE: "Itens por página",
  CANCEL: COMMON_TEXTS.CANCEL,
  CONFIRM: COMMON_TEXTS.CONFIRM,
  PROCESSING: "Processando...",
  ATTENTION: "Atenção",
  SELECT_AT_LEAST_ONE: "Selecione ao menos 1 produto",
  SUCCESS: COMMON_TEXTS.SUCCESS_TITLE,
  ERROR: "Erro",
  BULK_FAILED: "Erro ao processar ação em massa",
  INVALID_STORE: (storeCode: number): string => `storeCode inválido (${storeCode}). Verifique os dados.`,
  ITEM_DEACTIVATED_TITLE: "Produto desativado",
  ITEM_ACTIVATED_TITLE: "Produto ativado",
  ITEM_DEACTIVATED: (itemCode: string, storeCode: number): string =>
    `Item ${itemCode} (${COMMON_TEXTS.STORE_LABEL(storeCode)}) foi desativado`,
  ITEM_ACTIVATED: (itemCode: string, storeCode: number): string =>
    `Item ${itemCode} (${COMMON_TEXTS.STORE_LABEL(storeCode)}) foi ativado`,
  TOGGLE_FAILED: "Erro ao alterar status do item",
} as const;
